import { render, staticRenderFns } from "./AgedBalance.vue?vue&type=template&id=26b3d342&scoped=true&"
import script from "./AgedBalance.vue?vue&type=script&lang=js&"
export * from "./AgedBalance.vue?vue&type=script&lang=js&"
import style0 from "./AgedBalance.vue?vue&type=style&index=0&id=26b3d342&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b3d342",
  null
  
)

export default component.exports